import { SignatureDialog } from '@pbt/pbt-ui-components'
import type { SignatureDialogProps } from '@pbt/pbt-ui-components/src/components/signature/SignatureDialog'

import DoctorSignature, {
  type DoctorSignatureProps,
} from './signature/DoctorSignature'

interface DoctorSignatureDialogProps
  extends SignatureDialogProps, DoctorSignatureProps {}

const DoctorSignatureDialog = (props: DoctorSignatureDialogProps) => (
  <SignatureDialog SignatureComponent={DoctorSignature} {...props} />
)

export default DoctorSignatureDialog
